module.exports = [{"id":1,"title":"General Information"},{"id":2,"title":"Getting Technical Support"},{"id":3,"title":"Filing and Tracking a Claim"}]


//////////////////
// WEBPACK FOOTER
// ./packages/smart-home-support/pages/faqpage/resources/data/SHS-WEB/faq-topics.json
// module id = 3409
// module chunks = 0